import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import ChartFactory from "@/components/VueCharts/ChartFactory.vue";
let Analytics = class Analytics extends Vue {
    factoryData = [];
    isLoading = false;
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get isDevelopment() {
        return process.env.VUE_APP_PROJECT_ID === 'skistem-test';
    }
    created() {
        this.fetchData();
    }
    async getBiData() {
        return {
            balances: await this.$store.getters['balance/all'],
            instructors: await this.$store.getters['instructor/all'],
            transactions: await this.$store.getters['transaction/fetchAll'],
            works: await this.$store.getters['instructorTable/fetchAll'],
            prices: await this.$store.getters['pricing/all'],
        };
    }
    async downloadFile(url, filename = 'data') {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(await this.getBiData()),
        });
        if (!response.ok) {
            throw new Error("HTTP error " + response.status);
        }
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `${filename}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    async downloadXls() {
        await this.downloadFile(process.env.VUE_APP_BI_URL + '/xls');
    }
    async downloadPayout() {
        await this.downloadFile(process.env.VUE_APP_BI_URL + '/payout', 'vyplaty');
    }
    async fetchData() {
        this.isLoading = true;
        try {
            const url = process.env.VUE_APP_BI_URL + '/process';
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(await this.getBiData()),
            });
            this.factoryData = await response.json();
        }
        finally {
            this.isLoading = false;
        }
    }
};
Analytics = __decorate([
    Component({
        components: { ChartFactory }
    })
], Analytics);
export default Analytics;
